import CategoryListResourceModel from '../../generated/types/model/resource/CategoryListResourceModel';

export default class CategoryListResourceViewModel extends CategoryListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
